import { ActivityCard, ItineraryItem } from "./ActivityCard";

interface InfrastructureFeesSectionProps {
  items: ItineraryItem[];
}

/**
 * Programme-wide Infrastructure Fees block (Guide + S&Ts).
 * Rendered between the programme summary and Day 1.
 */
export function InfrastructureFeesSection({ items }: InfrastructureFeesSectionProps) {
  if (!items || items.length === 0) return null;

  return (
    <div className="rounded-lg overflow-hidden border bg-background">
      <div className="bg-secondary text-secondary-foreground px-6 py-4">
        <h3 className="text-xl font-bold tracking-wide">INFRASTRUCTURE FEES</h3>
        <p className="text-secondary-foreground/80 text-sm">Applies across the entire programme</p>
      </div>
      <div className="p-4 space-y-4">
        {items.map((item) => (
          <ActivityCard key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
}